import { Box, Button, Container, Grid } from "@material-ui/core";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { UserDataContext } from "../context/UserDataContext";
import { Close } from "@material-ui/icons";
import { Environment } from "../utils/environments";
import ConfirmationModal from "./ConfirmationModal";

export default function Header() {
  const [hideNavigation, setHideNavigation] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { userData, memberData } = useContext(UserDataContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef<any>(null);
  const displayLp = searchParams.get("display")
    ? searchParams.get("display")
    : undefined;
  const linkNames = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "サポートメニュー",
      link: "/support/menu",
    },
    {
      name: "お支払い履歴",
      link: "/purchase-list",
    },
  ];
  useEffect(() => {
    setHideNavigation(
      [
        "/error",
        "/login",
        "/registeration-temp",
        "/registeration-complete",
        "/password-reset",
        "/password-reset-request",
        "/password-reset-complete",
        "/signup",
      ].includes(location.pathname)
    );
  }, [location]);
  useEffect(() => {
    var body = document.querySelector("body");
    if (menuOpen) {
      body?.classList.add("menu-is-open");
    } else {
      body?.classList.remove("menu-is-open");
    }
  }, [menuOpen]);
  function handleLogout() {
    setModalOpen(false);
    signOut(auth);
    setMenuOpen(false);
    navigate("/login", { state: { from: "/" } });
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (Environment.getBuildType() != "prod") {
    console.log(userData && userData);
  }
  return (
    <Fragment>
      {displayLp != "lp" && (
        <Fragment>
          <Box className="header-wrapper" component={"header"}>
            <Box className="header">
              <Container className="container">
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item md={3} sm={3} xs={6}>
                    {![
                      "/login",
                      "/registeration-temp",
                      "/registeration-complete",
                      "/password-reset",
                      "/password-reset-request",
                      "/password-reset-complete",
                      "/signup",
                    ].includes(location.pathname) ? (
                      <Link to="/">
                        <img src={"/logo_yoko.png"}></img>
                      </Link>
                    ) : (
                      <Fragment>
                        {![
                          "/login",
                          "/signup",
                          "/password-reset-request",
                        ].includes(location.pathname) ? (
                          <Link to="/login">
                            <img src={"/logo_yoko.png"}></img>
                          </Link>
                        ) : (
                          <img src={"/logo_yoko.png"}></img>
                        )}
                      </Fragment>
                    )}
                  </Grid>
                  {!hideNavigation && (
                    <Grid
                      item
                      md={9}
                      sm={9}
                      xs={6}
                      style={{ textAlign: "right" }}
                    >
                      <div className="header-top-links">
                        <div className="memberId">
                          {memberData && (
                            <p>
                              会員ID: <span>{memberData.memberId}</span>
                            </p>
                          )}
                        </div>
                        <Link to="/settings">
                          <button className="user-button">
                            <img
                              src={"/images/person-icon.png"}
                              className="header-icon"
                            />
                            <span>お客様情報</span>
                          </button>
                        </Link>
                        <Link
                          to={"https://www.wons.co.jp/contact/"}
                          target="_blank"
                        >
                          <Button style={{ color: "var(--text-color-3)" }}>
                            お問い合わせ
                          </Button>
                        </Link>
                        {auth.currentUser ? (
                          <Button
                            style={{ color: "var(--text-color-3)" }}
                            onClick={(e) => {
                              setModalOpen(true);
                            }}
                          >
                            ログアウト
                          </Button>
                        ) : (
                          <Link to="/login">
                            <Button variant="outlined" color="primary">
                              ログイン
                            </Button>
                          </Link>
                        )}
                      </div>
                      <div className="mobile-navigation">
                        {auth.currentUser ? (
                          <button
                            className="user-button"
                            onClick={(e) => {
                              setModalOpen(true);
                            }}
                          >
                            <img
                              src={"/images/person-icon.png"}
                              className="header-icon"
                            />
                            <span>ログアウト</span>
                          </button>
                        ) : (
                          <Link to="/login">
                            <button
                              className="user-button"
                              onClick={(e) => {
                                setModalOpen(true);
                              }}
                            >
                              <img
                                src={"/images/person-icon.png"}
                                className="header-icon"
                              />
                              <span>ログイン</span>
                            </button>
                          </Link>
                        )}
                        <div
                          className={`hamburger-icon ${menuOpen ? "open" : ""}`}
                          onClick={() => {
                            setMenuOpen(!menuOpen);
                          }}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </Grid>
                  )}
                </Grid>
              </Container>
            </Box>
            {!hideNavigation && (
              <Box className="header-links-wrapper">
                <Container className="text-center container">
                  <div className="header-links-inline">
                    <div className="header-links">
                      {linkNames.map((link, idx) => (
                        <Link
                          to={link.link}
                          className={
                            window.location.pathname == link.link
                              ? "active"
                              : ""
                          }
                          key={idx}
                        >
                          {link.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </Container>
              </Box>
            )}
          </Box>
          <div
            ref={menuRef}
            className={`mobile-links-wrapper ${menuOpen ? "open" : ""}`}
          >
            <div className="mobile-logo-wrapper">
              <div className="mobile-menu-logo">
                <img src="/logo_yoko.png" />
              </div>
              <div
                className="menu-close"
                onClick={() => {
                  setMenuOpen(!menuOpen);
                }}
              >
                <Close />
              </div>
            </div>
            <div className="member-id">
              {memberData && (
                <p>
                  <span>会員ID: {memberData.memberId}</span>
                </p>
              )}
            </div>
            <div className="mobile-links">
              <Link
                to="/settings"
                onClick={() => setMenuOpen(!menuOpen)}
                className={
                  window.location.pathname == "/settings" ? "active" : ""
                }
              >
                <button className="user-button mobile-btn">
                  <img
                    src={"/images/person-icon.png"}
                    className="header-icon"
                  />
                  <span>お客様情報</span>
                </button>
              </Link>
              {linkNames.map((link, idx) => (
                <Link
                  to={link.link}
                  className={
                    window.location.pathname == link.link ? "active" : ""
                  }
                  key={idx}
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            {/* <div className="menu-links-bottom">
  <Link to="/settings" onClick={() => setMenuOpen(!menuOpen)}>
    <button className="user-button">
      <img
        src={"/images/person-icon.png"}
        className="header-icon"
      />
      <span>お客様情報</span>
    </button>
  </Link>
</div> */}
          </div>
          {modalOpen && (
            <ConfirmationModal
              open={modalOpen}
              heading={"ログアウト"}
              body={"ログアウトしてもよろしいですか？"}
              confirmButton={handleLogout}
              confirmButtonText={"ログアウト"}
              closeButton={setModalOpen}
              closeButtonText={"戻る"}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}
